module.exports = __webpack_public_path__ + "static/img/join_us04.e9393abc.jpg";